import { createSlice } from "@reduxjs/toolkit";

const modalSlice = createSlice({
  name: "modal",
  initialState: {
    openOnVisit: false,
    selectedCard: null,
    disableClicks: false,
  },
  reducers: {
    setOpenOnVisit: (state, action) => {
      state.openOnVisit = action.payload;
    },
    setSelectedCard: (state, action) => {
      state.selectedCard = action.payload;
    },
    setDisableClicks: (state, action) => {
      state.disableClicks = action.payload;
    },
  },
});

export const { setOpenOnVisit, setSelectedCard, setDisableClicks } =
  modalSlice.actions;
export default modalSlice.reducer;
